<template>
  <div class="bpm-participants-step flex-grow-1 min-h-0 h-100 d-flex flex-column">
    <section class="insurer flex-shrink-0 mb-3">
      <h6 class="mb-5 text-gray-700">Страхователь</h6>
      <div class="bpm-scroll-area">
        <customer-bpm-card
          v-if="policy.insurer"
          variant="wide"
          :changeDisabled="changeDisabled"
          :client="policy.insurer"
          :key-item="0"
          :has-paid="policy.hasPaid"
          :mode="mode"
          :module="module"
          @retry-verify="$emit('retry-client-verify', policy.insurer)"
        >
          <template v-slot:footer>
            <div class="pt-2 pb-4">
              <switch-box-field
                :model-value="policy.isDrive"
                placeholder="Будет управлять авто"
                id="is.driver"
                :size="'h-20px w-30px'"
                class="justify-content-center"
                @update:model-value="$emit('update:is-drive', $event)"
              />
            </div>
          </template>
          <template v-slot:change>
            <span
              v-if="mode.canSwitchInsurer() && policy.insureds.filter(item => item.client.iin !== policy.insurer.client.iin).length"
              class="switch-item"
              title="Заменить страхователя"
              @click="$emit('switch-insurer')"
            >
              <i class="ki-outline ki-right-square fs-3"></i>
            </span>
            <span
              v-if="mode.canEditInsurer() && !hasPodftError(policy.insurer)"
              class="edit-item"
              title="Редактировать страхователя"
              @click="$emit('open-client-modal', 1, policy.insurer)"
            >
              <i class="ki-outline ki-notepad-edit fs-3"></i>
            </span>
            <span
              v-if="mode.canDeleteInsurer()"
              class="delete-item"
              title="Удалить страхователя"
              @click="$emit('delete-insurer')"
            >
              <i class="ki-outline ki-cross-square fs-3"></i>
            </span>
          </template>
        </customer-bpm-card>
        <template v-if="activeBpProcessesByType[1].length">
          <customer-bpm-empty-card
            v-for="item in activeBpProcessesByType[1]"
            variant="wide"
            :id="item.id"
            :key="item.id"
            :changeDisabled="changeDisabled"
            :status-code="item.process_data.waiting_action"
            :status-name="item.process_data.message"
            :status="item.process_data.status"
            :bp-status="item.status"
            :data="item.meta"
            :mode="mode"
            :module="module"
            @start-action="$emit('change-process-status', item.id, 1)"
            @next-action="$emit('open-bpm-modal', item.id)"
          >
            <template v-slot:change>
              <span
                v-if="mode.canEditInsurer() && isProcessRejected(item.process_data)"
                class="edit-item"
                title="Редактировать страхователя"
                @click="$emit('edit-rejected-client', 1, item.id)"
              >
                <i class="ki-outline ki-notepad-edit fs-3"></i>
              </span>
              <span
                v-if="mode.canDeleteInsurer()"
                class="delete-item"
                title="Удалить страхователя"
                @click="$emit('delete-process', item.id)"
              >
                <i class="ki-outline ki-cross-square fs-3"></i>
              </span>
            </template>
          </customer-bpm-empty-card>
        </template>
        <div
          v-if="mode.canAddInsurer() && !policy.insurer && !changeDisabled && module.Validator.isShowInsurerAddButton(policy.insureds, policy.vehicle, policy.business_process)"
          class="empty-card"
          style="margin-bottom: 12px;"
          @click="$emit('add-insurer')"
        >
          <span class="fs-7 text-primary">Добавить страхователя</span>
        </div>
      </div>
    </section>
    <div class="d-flex flex-column flex-xl-row gx-3 bpm-participants-row flex-grow-1 min-h-0 align-items-stretch">
      <div class="col-12 col-xl-6 bpm-participants-col d-flex flex-column min-h-0 pb-1">
        <section class="insureds-section d-flex flex-column flex-grow-1 min-h-0 mb-0">
          <h6 class="mb-5 text-gray-700 flex-shrink-0">{{ blockSectionTitle('Водители', 2, 'insureds') }}</h6>
          <div class="insureds-list bpm-scroll-area">
            <template v-if="policy.insureds.length">
              <customer-bpm-card
                v-for="(item, key) in policy.insureds"
                variant="default"
                :key="key"
                :changeDisabled="changeDisabled"
                :key-item="key"
                :client="item"
                :has-paid="policy.hasPaid"
                :mode="mode"
                :module="module"
                @retry-verify="$emit('retry-client-verify', item)"
              >
                <template v-if="!changeDisabled" v-slot:change>
                  <span
                    v-if="mode.canEditInsured() && !hasPodftError(item)"
                    class="edit-item"
                    title="Редактировать водителя"
                    @click="$emit('open-client-modal', 2, item, key)"
                  >
                    <i class="ki-outline ki-notepad-edit fs-3"></i>
                  </span>
                  <span
                    v-if="mode.canDeleteInsured()"
                    class="delete-item"
                    title="Удалить водителя"
                    @click="$emit('delete-insured', key)"
                  >
                    <i class="ki-outline ki-cross-square fs-3"></i>
                  </span>
                </template>
              </customer-bpm-card>
            </template>
            <template v-if="activeBpProcessesByType[2].length">
              <customer-bpm-empty-card
                v-for="item in activeBpProcessesByType[2]"
                variant="default"
                :id="item.id"
                :key="item.id"
                :changeDisabled="changeDisabled"
                :status-code="item.process_data.waiting_action"
                :status-name="item.process_data.message"
                :status="item.process_data.status"
                :bp-status="item.status"
                :data="item.meta"
                :mode="mode"
                :module="module"
                @next-action="$emit('open-bpm-modal', item.id)"
                @start-action="$emit('change-process-status', item.id, 1)"
              >
                <template v-if="!changeDisabled" v-slot:change>
                  <span
                    v-if="mode.canEditInsured() && isProcessRejected(item.process_data)"
                    class="edit-item"
                    title="Редактировать водителя"
                    @click="$emit('edit-rejected-client', 2, item.id)"
                  >
                    <i class="ki-outline ki-notepad-edit fs-3"></i>
                  </span>
                  <span
                    v-if="mode.canDeleteInsured()"
                    class="delete-item"
                    title="Удалить водителя"
                    @click="$emit('delete-process', item.id)"
                  >
                    <i class="ki-outline ki-cross-square fs-3"></i>
                  </span>
                </template>
              </customer-bpm-empty-card>
            </template>
            <template v-if="!changeDisabled && module.Validator.isShowInsuredsAddButton(policy.insureds, policy.vehicle, policy.business_process)">
              <div
                v-if="mode.canAddInsured()"
                class="empty-card"
                @click="$emit('add-insured')"
              >
                <span class="fs-7 text-primary">Добавить водителя</span>
              </div>
            </template>
          </div>
        </section>
      </div>
      <div class="col-12 col-xl-6 bpm-participants-col d-flex flex-column min-h-0 pb-1">
        <section class="auto-section d-flex flex-column flex-grow-1 min-h-0 mb-0">
          <h6 class="mb-5 text-gray-700 flex-shrink-0">{{ blockSectionTitle('Авто', 3, 'vehicle') }}</h6>
          <div class="vehicles-list bpm-scroll-area">
            <template v-if="policy.vehicle.length">
              <vehicle-bpm-card
                v-for="(item, key) in policy.vehicle"
                variant="default"
                :key="key"
                :changeDisabled="changeDisabled"
                :vehicle="item"
                :mode="mode"
                @retry-verify="$emit('retry-vehicle-verify', item)"
              >
                <template v-if="!changeDisabled" v-slot:change>
                  <span
                    v-if="mode.canEditVehicle() && !hasPodftError(item)"
                    class="edit-item"
                    title="Редактировать авто"
                    @click="$emit('set-changed-vehicle', key)"
                  >
                    <i class="ki-outline ki-notepad-edit fs-3"></i>
                  </span>
                  <span
                    v-if="mode.canDeleteVehicle()"
                    class="delete-item"
                    title="Удалить авто"
                    @click="$emit('delete-vehicle', key)"
                  >
                    <i class="ki-outline ki-cross-square fs-3"></i>
                  </span>
                </template>
              </vehicle-bpm-card>
            </template>
            <template v-if="activeBpProcessesByType[3].length">
              <vehicle-bpm-empty-card
                v-for="item in activeBpProcessesByType[3]"
                variant="default"
                :id="item.id"
                :key="item.id"
                :changeDisabled="changeDisabled"
                :status-code="item.process_data.waiting_action"
                :status-name="item.process_data.message"
                :status="item.process_data.status"
                :bp-status="item.status"
                :data="item.meta"
                :mode="mode"
                :module="module"
                @next-action="$emit('open-bpm-modal', item.id)"
                @start-action="$emit('change-process-status', item.id, 1)"
              >
                <template v-slot:change>
                  <span
                    v-if="mode.canEditVehicle() && isProcessRejected(item.process_data)"
                    class="edit-item"
                    title="Редактировать авто"
                    @click="$emit('edit-rejected-vehicle', item.id)"
                  >
                    <i class="ki-outline ki-notepad-edit fs-3"></i>
                  </span>
                  <span
                    v-if="mode.canDeleteVehicle()"
                    class="delete-item"
                    title="Удалить авто"
                    @click="$emit('delete-process', item.id)"
                  >
                    <i class="ki-outline ki-cross-square fs-3"></i>
                  </span>
                </template>
              </vehicle-bpm-empty-card>
            </template>
            <template v-if="!changeDisabled && module.Validator.isShowVehicleAddButton(policy.insureds, policy.vehicle, policy.business_process)">
              <div
                v-if="mode.canAddVehicle()"
                class="empty-card"
                @click="$emit('set-changed-vehicle', null, true)"
              >
                <span class="fs-7 text-primary">Добавить авто</span>
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerBpmEmptyCard from '@/components/Form/Bpm/Customer/CustomerBpmEmptyCard'
import CustomerBpmCard from '@/components/Form/Bpm/Customer/CustomerBpmCard'
import VehicleBpmCard from '@/components/Form/Bpm/Vehicle/VehicleBpmCard'
import VehicleBpmEmptyCard from '@/components/Form/Bpm/Vehicle/VehicleBpmEmptyCard'
import SwitchBoxField from '@/components/Fields/SwitchBoxField'

export default {
  name: 'BpmOgpoParticipantsStep',
  components: {
    CustomerBpmCard,
    CustomerBpmEmptyCard,
    VehicleBpmCard,
    VehicleBpmEmptyCard,
    SwitchBoxField,
  },
  props: {
    policy: {
      type: Object,
      required: true,
    },
    mode: {
      type: [Object, Function],
      required: true,
    },
    module: {
      type: Function,
      required: true,
    },
    changeDisabled: {
      type: Boolean,
      default: false,
    },
    activeBpProcessesByType: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'switch-insurer',
    'open-client-modal',
    'delete-insurer',
    'change-process-status',
    'open-bpm-modal',
    'edit-rejected-client',
    'delete-process',
    'add-insurer',
    'delete-insured',
    'add-insured',
    'set-changed-vehicle',
    'delete-vehicle',
    'edit-rejected-vehicle',
    'update:is-drive',
    'retry-client-verify',
    'retry-vehicle-verify',
  ],
  methods: {
    hasPodftError(entity) {
      return !!(entity && entity.podft && entity.podft.success === false)
    },
    blockSectionTitle(label, processType, policyKey) {
      const items = this.policy?.[policyKey]
      const count = (Array.isArray(items) ? items.length : 0)
        + (this.activeBpProcessesByType[processType]?.length ?? 0)
      return count >= 4 ? `${label} (${count})` : label
    },
    isProcessRejected(processData) {
      return !!(processData && ['FAILED', 'TIME_OUT', 'TIMED_OUT'].includes(String(processData.status)))
    },
  },
}
</script>
